
export default {
  name: "SalesIndex"
}
